<template>
  <v-container>
    <v-subheader class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
      <v-icon color="blue darken-2">mdi-thumb-up-outline</v-icon>
      <span class="ml-2">{{$t('lang.questionnaire')}}</span>
    </v-subheader>
    <v-card class="mx-4 mx-sm-12 my-sm-8" tile outlined v-if="step == 1">
      <v-card-title class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
        {{$t('lang.confirmationInformation')}}
      </v-card-title>
      <v-divider class="blue"></v-divider>
      <v-form v-model="valid" ref="form">
        <v-row no-gutters>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-6">
            <span class="my-auto ml-4">{{$t('lang.name')}}：</span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field outlined clearable class="mt-4 mx-4" :placeholder="$t('lang.nameOfParticipant')" required :rules="nameRules" v-model="name" dense></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" class="mt-6">
            <span class="my-auto ml-4">{{$t('lang.phoneOrEmail')}}：</span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field outlined clearable class="mt-4 mx-4" :placeholder="$t('lang.phoneOfParticipant')" required :rules="numberRules" v-model="number" dense></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="justify-center">
        <v-btn style="text-transform:none;" large color="primary" class="px-10" @click="validateN" :loading="loading">{{$t('lang.confirm')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mx-4 mx-sm-12 my-sm-8" tile outlined v-if="step == 2" >
      <!-- <v-card-title class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
        满意度调查
      </v-card-title>
      <v-divider class="blue"></v-divider> -->
        <v-btn-toggle v-model="SatisfactionState" class="my-8" tile style="width:100%;">
          <v-row no-gutters>
            <v-col cols="12" sm="3" class="d-flex">
              <v-btn class="mx-auto my-3" active-class="primary white--text" width="80%">{{$t('lang.excellent')}}</v-btn>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex">
              <v-btn class="mx-auto my-3" active-class="primary white--text" width="80%">{{$t('lang.good')}}</v-btn>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex">
              <v-btn class="mx-auto my-3" active-class="primary white--text" width="80%">{{$t('lang.average')}}</v-btn>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex">
              <v-btn class="mx-auto my-3" active-class="primary white--text" width="80%">{{$t('lang.unsatisfactory')}}</v-btn>
            </v-col>
          </v-row>
        </v-btn-toggle>

      <v-card-actions class="justify-center">
        <v-btn style="text-transform:none;" large color="primary" class="px-10" @click="submit" :loading="loading">{{$t('lang.submit')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<style>
.theme--light.v-sheet--outlined {
  border: thin solid #2196F3;
}
</style>
<script>
export default {
  name: 'Survey',
  props: ['data'],
  data: () => ({
    UserSignUpId: '',
    step: 1,
    name: '',
    number: '',
    valid: true,
    loading: false,
    nameRules: [],
    numberRules: [],
    SatisfactionState: null,
    snackbar: false,
    msg: ''
  }),
  mounted () {
    this.initRoles()
  },
  methods: {
    initRoles () {
      this.nameRules = [
        v => !!v || this.$t('lang.nameCannotBeEmpty')
      ]
      this.numberRules = [
        v => !!v || this.$t('lang.phoneOrEmailCannotBeEmpty'),
        v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || this.$t('lang.correctPhoneOrEmail')
      ]
    },
    validateN () {
      this.initRoles()
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API',
          url: '/SignUp/ValidUserSignUpInfo',
          data: {
            SignUpId: this.data.SignUpId,
            UserName: this.name,
            Phone: this.number
          }
        }).then(res => {
          console.log(res)
          this.loading = false
          if (res.data.ret === 0) {
            this.step = 2
            this.UserSignUpId = res.data.data.UserSignUpId
          } else {
            this.msg = res.data.msg
            this.snackbar = true
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    submit () {
      if (this.SatisfactionState == null) {
        this.msg = this.$t('lang.selectAtLeastOne')
      } else {
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API',
          url: '/SignUp/SetUserSignUpSatisfactionState',
          data: {
            UserSignUpId: this.UserSignUpId,
            SatisfactionState: (this.SatisfactionState + 1)
          }
        }).then(res => {
          this.loading = false
          if (res.data.ret === 0) {
            this.step = 1
            this.msg = this.$t('lang.submittedSuccessfully')
          } else {
            this.msg = res.data.msg
          }
        }).catch(e => {
          console.log(e)
        })
      }
      this.snackbar = true
    }
  }
}
</script>
